{
  "maximum": "Максимум",
  "minimum": "Минимум"
}
